import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/core/services/api/api.service';
import { QueryParameters } from '@app/core/entities/query-parameters.class';
import { DeliverCursorPaginationService } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.service';
import { DeliverCursorPagination } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.model';
import { TABLES } from '@utils/table.utils';

@Injectable()
export class AssignCursorPaginationService extends DeliverCursorPaginationService<
  DeliverCursorPagination.AssignTabCounters,
  DeliverCursorPagination.AssignTabCountersPayload
> {
  private apiService = inject(ApiService);

  table = TABLES.ASSIGN;

  protected fetchOrdersFromApi(
    params: DeliverCursorPagination.OrdersRequest,
  ): Observable<DeliverCursorPagination.OrdersResponse> {
    return this.apiService.post('order/v2/orders', params);
  }

  protected fetchCountFromApi(query: QueryParameters): Observable<DeliverCursorPagination.CappedCount> {
    return this.apiService.post('order/v2/count', query);
  }

  protected fetchTabCountersFromApi(
    payload?: DeliverCursorPagination.AssignTabCountersPayload,
  ): Observable<DeliverCursorPagination.AssignTabCounters> {
    return this.apiService.post('order/v2/tab-count/assign', payload ?? {});
  }
}
